import { useEffect, useState } from 'react'
import { Button, Typography, IconButton } from '@material-tailwind/react'
import { Link, Navigate, useLocation, useSearchParams } from 'react-router-dom'
import { MdArrowBack } from 'react-icons/md'
import { useTranslation } from 'react-i18next'
import { colors } from '@material-tailwind/react/types/generic'
import { useSessionContext } from '../contexts/SessionContext'
import { useDarkMode } from '../contexts/DarkModeContext'
import { usePageTitle } from '../hooks/toolkit'
import Container from '../components/Container'
import FinalizeUserForm from '../components/FinalizeUserForm'
import FinalizeUserTitle from '../components/FinalizeUserTitle'

const UserFinalize = () => {
  const { t } = useTranslation()
  const { darkMode } = useDarkMode()

  usePageTitle(t('userFinalize.pageTitle'))

  const location = useLocation()

  const [searchParams] = useSearchParams()

  const codeParam = searchParams.get('redeemCode')

  const { user } = useSessionContext()

  const [userType, setUserType] = useState<'indiegogo' | 'bch-owner' | 'profile-only' | null>(null)

  useEffect(() => {
    if (codeParam) {
      setUserType('indiegogo')
    }
  }, [])

  // send a logged user to its dashboard
  if (user?.finalized) {
    return <Navigate to="/" state={{ from: location }} replace />
  }

  return (
    <Container direction="col">
      <FinalizeUserTitle userType={userType || undefined} />

      {!userType && (
        <div className="w-full md:w-1/2 flex flex-col gap-8">
          <Button
            variant="outlined"
            color={(darkMode ? 'white' : 'primary') as colors}
            onClick={() => setUserType('indiegogo')}
          >
            {t('userFinalize.indiegogoSupporter')}
          </Button>

          <Button
            variant="outlined"
            color={(darkMode ? 'white' : 'primary') as colors}
            onClick={() => setUserType('bch-owner')}
          >
            {t('userFinalize.bchOwner')}
          </Button>

          <Button
            variant="outlined"
            color={(darkMode ? 'white' : 'primary') as colors}
            onClick={() => setUserType('profile-only')}
          >
            {t('userFinalize.profileOnly')}
          </Button>
        </div>
      )}

      {userType && (
        <>
          <IconButton
            className="self-start"
            variant="text"
            color={(darkMode ? 'white' : 'primary') as colors}
            size="lg"
            onClick={() => setUserType(null)}
          >
            <MdArrowBack className="text-3xl" />
          </IconButton>
          <FinalizeUserForm userType={userType} />
        </>
      )}

      {!userType && (
        <>
          <hr className="w-full md:w-1/2 my-6 opacity-50" />

          <div className="flex w-full justify-center items-center gap-2 my-2">
            <Typography>{t('userFinalize.dontHaveBch')}</Typography>
            <Link
              to="https://www.indiegogo.com/projects/agami-everywhere-immersive-sound"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Typography className="underline font-bold">{t('userFinalize.buyNow')}</Typography>
            </Link>
          </div>
        </>
      )}
    </Container>
  )
}

export default UserFinalize
